const deleteReferralDenied = {
    title: 'Ошибка удаления',
    description: 'Нельзя удалить акцию, если в ней принимают участие',
} as const;

export default deleteReferralDenied;
